import merge from 'classnames';

import { OpportunityShortInfo } from '@/controllers/Opportunity';
import { selectRequestError, selectRequestStatus } from '@/store/reducers/api-requests/selectors';
import { ReduxAxiosError } from '@/store/reducers/api-requests/types';
import { AppState, OpportunityVm } from '@/types';

import { OpportunitiesReducerState } from './types';

export const selectOpportunitiesState = (state: AppState): OpportunitiesReducerState => {
  return state.opportunities;
};

export const selectOpportunities = (state: AppState): OpportunitiesReducerState['list'] => {
  return selectOpportunitiesState(state).list;
};

export const selectOpportunitiesShortInfo = (state: AppState): OpportunityShortInfo[] => {
  return selectOpportunities(state).map((opportunity): OpportunityShortInfo => {
    const { firstName, lastName, addressLine1 } = opportunity.contact;

    let title = merge(firstName, lastName);

    if (title.length === 0) title = 'Customer name was not provided';
    if (addressLine1) title += `, ${addressLine1}`;

    return {
      id: opportunity.id,
      title,
      contact: opportunity.contact,
      syncedProposalId: opportunity.syncedProposalId,
    };
  });
};

export const selectOpportunityStageIsUpdating = (state: AppState): boolean => {
  return selectRequestStatus(state, 'opportunities|changeStatus');
};

export const selectOpportunityStageChangeError = (state: AppState): ReduxAxiosError => {
  return selectRequestError(state, 'opportunities|changeStatus');
};

export const selectNewOpportunity = (state: AppState): OpportunityVm | null => {
  return selectOpportunitiesState(state).newOpportunity;
};
